import React from "react";
import { Backdrop, Box, Button, Stack, Typography } from "@mui/material";
import WifiOffRoundedIcon from "@mui/icons-material/WifiOffRounded";

const formatDateTime = (value) => {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return "";
  return value.toLocaleString();
};

export default function OfflineLockOverlay({ open, lastOnlineAt, onRetry }) {
  return (
    <Backdrop
      open={Boolean(open)}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 2000,
        bgcolor: "rgba(11, 14, 30, 0.68)",
        p: 2,
      }}
    >
      <Box
        role="alert"
        sx={{
          width: "100%",
          maxWidth: 560,
          borderRadius: 2,
          px: { xs: 2.5, sm: 4 },
          py: { xs: 3, sm: 4 },
          bgcolor: "background.paper",
          boxShadow: "0 22px 50px rgba(0, 0, 0, 0.28)",
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Stack spacing={1.5}>
          <Stack direction="row" spacing={1.25} alignItems="center">
            <WifiOffRoundedIcon color="warning" />
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Connection lost
            </Typography>
          </Stack>
          <Typography variant="body1" color="text.secondary">
            You're offline right now. We temporarily locked editing so nothing breaks or gets lost.
            As soon as your internet connection comes back, the app unlocks automatically.
          </Typography>
          {lastOnlineAt ? (
            <Typography variant="caption" color="text.secondary">
              Last seen online: {formatDateTime(lastOnlineAt)}
            </Typography>
          ) : null}
          <Stack direction="row" spacing={1.25}>
            <Button variant="contained" onClick={onRetry}>
              Try Again
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Backdrop>
  );
}
